import React from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  children: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({ label, required, error, hint, children }) => {
  return (
    <div style={{ marginBottom: '16px' }}>
      <label
        style={{
          display: 'block',
          marginBottom: '4px',
          fontWeight: 500,
          fontSize: '14px',
          color: '#374151',
        }}
      >
        {label}
        {required && <span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>}
      </label>
      {children}
      {hint && !error && (
        <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#9ca3af' }}>{hint}</p>
      )}
      {error && (
        <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#ef4444' }}>{error}</p>
      )}
    </div>
  );
};

export default FormField;
